<script setup>
import { ref } from 'vue';

defineProps({
  name: { type: String, required: true },
  label: { type: String, required: true },
  type: { type: String, default: 'text' },
  error: { type: String, default: '' },
  describedBy: { type: String, default: undefined },
});
defineOptions({ inheritAttrs: false });
const model = defineModel({ type: String, default: '' });
const visible = ref(false);
</script>

<template>
  <div>
    <label :for="name" class="mb-2 block text-sm font-medium text-slate-900">
      {{ label }}
    </label>
    <div class="relative">
      <input
        :id="name"
        v-model="model"
        v-bind="$attrs"
        :name="name"
        :type="type === 'password' && visible ? 'text' : type"
        :aria-invalid="Boolean(error)"
        :aria-describedby="
          [describedBy, error ? `${name}-error` : '']
            .filter(Boolean)
            .join(' ') || undefined
        "
        class="!mb-0 !h-12 !w-full !rounded-xl !border !bg-slate-25/50 !px-4 !text-base !text-slate-900 !shadow-none transition-colors placeholder:!text-slate-600 hover:!border-slate-300 focus:!border-woot-600 focus:!bg-white focus:!outline-none focus:!ring-4 focus:!ring-woot-100/60 disabled:!opacity-60"
        :class="[
          error ? '!border-red-500' : '!border-slate-200',
          { '!pr-12': type === 'password' },
        ]"
      />
      <button
        v-if="type === 'password'"
        type="button"
        class="absolute inset-y-0 right-0 flex w-12 items-center justify-center rounded-xl text-slate-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-woot-600"
        :aria-label="
          $t(visible ? 'REGISTER.PASSWORD.HIDE' : 'REGISTER.PASSWORD.SHOW')
        "
        :aria-pressed="visible"
        @click="visible = !visible"
      >
        <span
          :class="visible ? 'i-lucide-eye-off' : 'i-lucide-eye'"
          class="size-5"
        />
      </button>
    </div>
    <p
      v-if="error"
      :id="`${name}-error`"
      role="alert"
      class="mb-0 mt-2 text-sm text-red-700"
    >
      {{ error }}
    </p>
  </div>
</template>
